import getCardRelationshipsData from "../services/api/getCardRelationshipsData";
import { postEmptyCardRelationshipsData } from "../services/api/postEmptyCardRelationshipsData";
import { fetchNetlifyAuthToken } from "../services/api/netlifyAuthToken";

export async function migrateOldDataToNetlify({ t, orgId }) {
  console.log(`Attempting migration for orgId=${orgId}`);

  try {
    // 1) Fetch the existing migration list
    const token = await fetchNetlifyAuthToken();
    const listResponse = await fetch(
      "/.netlify/functions/cardRelationshipsApi?organizationId=cardRelationshipsMigrationList",
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    const listText = await listResponse.json();
    let migrationList = JSON.parse(listText);

    // 2) If not in the list, read old Trello data
    const oldTrelloData = await t.get(
      "organization",
      "shared",
      "cardRelationships"
    );
    if (!oldTrelloData || Object.keys(oldTrelloData).length === 0) {
      // No old data to migrate, just mark migration done
      migrationList[orgId] = {
        migrationDate: new Date().toISOString(),
        trelloDataCleanup: true, // no data to remove
      };
      const version = new Date().toISOString();
      await postEmptyCardRelationshipsData({ t, version });
      await postMigrationList(migrationList);
      return {};
    }

    // 3) Save old data to Netlify
    const version = new Date().toISOString();
    const saveResp = await fetch("/.netlify/functions/cardRelationshipsApi", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify({
        organizationId: orgId,
        version,
        data: oldTrelloData,
      }),
    });
    if (!saveResp.ok) {
      throw new Error("Failed to save old Trello data to Netlify");
    }

    // 4) Update the migration list with date + no cleanup
    migrationList[orgId] = {
      migrationDate: version,
      trelloDataCleanup: false,
    };
    await postMigrationList(migrationList);

    // 5) Re-fetch from netlify to confirm
    console.log(`Migration was successful for orgId=${orgId}`);
    const data = await getCardRelationshipsData(t);

    return data;
  } catch (error) {
    console.error("Migration error for org", orgId, error);
    return {};
  }
}

async function postMigrationList(migrationList) {
  const token = await fetchNetlifyAuthToken();
  const version = new Date().toISOString();
  await fetch("/.netlify/functions/cardRelationshipsApi", {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      organizationId: "cardRelationshipsMigrationList",
      version,
      data: migrationList,
    }),
  });
}
